var StatelessReactViewController = /** @class */ (function () {
    function StatelessReactViewController(defaultRenderer) {
        this.defaultRenderer = defaultRenderer;
        this.render = this.render.bind(this);
        this.createElement = this.createElement.bind(this);
    }
    StatelessReactViewController.prototype.render = function () {
        return this.createElement();
    };
    StatelessReactViewController.prototype.createElement = function () {
        var _a, _b;
        return (_b = (_a = this.defaultRenderer) === null || _a === void 0 ? void 0 : _a.call(this)) !== null && _b !== void 0 ? _b : null;
    };
    return StatelessReactViewController;
}());
export { StatelessReactViewController };
//# sourceMappingURL=StatelessReactViewController.js.map